import axios from 'axios'
import { failureMsg } from '../utils/message'
import router from '../router/index'
import config from '@/config'
const service = axios.create({
  timeout: 600000, // request timeout
  // headers: { "content-type": "application/x-www-form-urlencoded" }
  headers:{
    "cache-control":"no-cache"
  }
})



service.interceptors.request.use(
  config => {
    // 添加，添加时间戳，为了防止ie浏览器缓冲的问题
    if (config.method === 'get') {
      config.params= {...config.params,t:Date.parse(new Date())}
    }
    return config
  },
  error => {
    return Promise.reject(error)
  }
)
service.interceptors.response.use(
  response => {
    const res = response.data
    if (1 * res.err_code) {
      failureMsg(res.err_msg)
    }
    if(res.err_code==401&&config.version=="h5"){
      window.sessionStorage.clear()
      router.replace("/login")
    }

    // 这里是在导出的文件的时候需要 content-disposition 里面的数据，如果 content-disposition 不为空就直接导出 response
    if(response.headers['content-disposition']) {
      return response
    }
    return res
  },
  error => {
    failureMsg('网络异常！！！')
    return Promise.reject(error)
  }
)

export default service
